module.exports = __webpack_public_path__ + "static/media/linksys.b1d597fc.svg";